export const PinSpaceRepository = Symbol('PinSpaceRepository');
